/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './segment-list-page.component.html';

import {LocalUserProfile} from '../../components/session/local-user-profile';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../common/controller/signal-admin-resource-list-state';
import {SegmentApiService, SegmentModel} from './segment-api.service';
import {AppSharedModule} from '../common/app-shared.module';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, AdminResourcePagesModule],
  selector: 'adn-segment-list-page',
  template
})
export class SegmentListPageComponent implements OnInit {
  readonly itemStateName = 'app.dat-seg.segments.segment';
  readonly mode = inject(LocalUserProfile).getCurrentApp() === 'ADVERTISING' ? 2 : 1;
  readonly columns: SignalAdminListColumn[] = this.mode === 2
    ? [{param: 'name'}, {param: 'type'}, {labelInstant: 'Publisher', param: '', sortable: false}]
    : [
      {param: 'name'},
      {label: 'label', param: '', sortable: false},
      {label: 'members', param: '', sortable: false},
      {label: 'folders', param: '', sortable: false}
    ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<SegmentModel>(
    inject(SegmentApiService),
    {listId: 'fullSegmentList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
